<template>
    <div class="card" v-if="!showTable">
        <div class="card-body p-0">
            <div class="card-px text-center py-20 my-10">
                <h2 class="fs-2x fw-bolder mb-10">{{ $t('pages.verificationRequest.create.title') }}</h2>
                <p class="text-gray-400 fs-5 fw-bold mb-13">
                    <span>{{ $t('pages.verificationRequest.create.description') }}</span>
                </p>
                <button type="button" class="btn btn-primary er fs-6 px-8 py-4" @click="newVerifyRequest">{{ $t('pages.verificationRequest.create.request') }}</button>
            </div>
            <div class="text-center px-5">
                <img src="/media/illustrations/sketchy-1/1.png" alt="" class="mw-100 mh-300px">
            </div>
        </div>
    </div>
    <custom-table
        v-else
        :title="$t('pages.verificationRequest.title')"
        :subTitle="$t('pages.verificationRequest.subTitle')"
        :items="table.data"
        :loading="table.loading"
        :columns="fields"
        :actions="actions"
        :pagination="table.pagination"
        @action="handleClickAction"
        @changeTable="handleTableChange">
        <template v-slot:status="{ row: record }">
            <span :class="status[record.status_id].badge" class="badge">{{ $t('pages.verificationRequest.status.' + status[record.status_id].code) }}</span>
        </template>
        <template v-slot:createdAt="{ row: record }">
            {{ $moment(record.created_at).format("DD.MM.YYYY - HH:mm:ss") }}
        </template>
        <template v-slot:actions="{ row: record }">
            <div class="d-flex justify-content-end">
                <router-link :to="'/verification-request/detail/' + record.id" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                    <span class="svg-icon svg-icon-3">
                        <inline-svg src="/media/icons/duotune/general/gen004.svg" />
                    </span>
                </router-link>
            </div>
        </template>
    </custom-table>
    <div class="modal fade" id="kt_modal_verify_request" ref="verifyRequestModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered mw-650px">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="fw-bolder">{{ form.title }}</h2>
                    <div id="kt_modal_add_customer_close" data-bs-dismiss="modal" class="btn btn-icon btn-sm btn-active-icon-primary">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="/media/icons/duotune/arrows/arr061.svg"/>
                        </span>
                    </div>
                </div>
                <el-form @submit.prevent="onSubmit()" :model="form.data" ref="verifyRequestForm">
                    <div class="modal-body py-10 px-lg-17">
                        <div class="scroll-y me-n7 pe-7" id="kt_modal_add_customer_scroll" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto" data-kt-scroll-dependencies="#kt_modal_add_customer_header" data-kt-scroll-wrappers="#kt_modal_add_customer_scroll" data-kt-scroll-offset="300px">
                            <div class="fv-row mb-7">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.verificationRequest.create.cols.content') }}</label>
                                <el-form-item prop="content" :rules="$validation.getMessage(['required'])">
                                    <el-input v-model="form.data.content" type="textarea" rows="5"/>
                                </el-form-item>
                            </div>
                            <div class="fv-row mb-7">
                                <label class="fs-6 fw-bold mb-2">{{ $t('pages.verificationRequest.create.cols.identity') }}</label>
                                <el-form-item prop="file">
                                    <el-upload :file-list="form.identity.fileList" :accept="verifyRequestAcceptFiles" class="upload-file" :on-change="(file, fileList) => handleChangeFile('identity', file, fileList)" :on-remove="(file, fileList) => handleChangeFile('identity', file, fileList)" :auto-upload="false" drag multiple>
                                        <el-icon class="el-icon--upload">
                                             <span class="svg-icon">
                                                 <inline-svg src="/media/icons/duotune/files/fil022.svg"/>
                                             </span>
                                        </el-icon>
                                        <div class="el-upload__text">{{ $t('pages.verificationRequest.create.upload.dragFile') }}</div>
                                    </el-upload>
                                </el-form-item>
                            </div>
                            <div class="fv-row mb-7">
                                <label class="fs-6 fw-bold mb-2">{{ $t('pages.verificationRequest.create.cols.certificate') }}</label>
                                <el-form-item prop="file">
                                    <el-upload :file-list="form.certificate.fileList" :accept="verifyRequestAcceptFiles" class="upload-file" :on-change="(file, fileList) => handleChangeFile('certificate', file, fileList)" :on-remove="(file, fileList) => handleChangeFile('certificate', file, fileList)" :auto-upload="false" drag multiple>
                                        <el-icon class="el-icon--upload">
                                             <span class="svg-icon">
                                                 <inline-svg src="/media/icons/duotune/files/fil022.svg"/>
                                             </span>
                                        </el-icon>
                                        <div class="el-upload__text">{{ $t('pages.verificationRequest.create.upload.dragFile') }}</div>
                                    </el-upload>
                                </el-form-item>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer flex-center">
                        <button :data-kt-indicator="form.loading ? 'on' : null" class="btn btn-lg btn-primary" type="submit" :disabled="form.loading">
                            <span v-if="!form.loading" class="indicator-label">{{ $t("btn.send") }}</span>
                            <span v-if="form.loading" class="indicator-progress">
                                {{ $t("messages.wait") }}
                                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import CustomTable from "@/components/custom-table";

export default {
    name: "index",
    components: {
        CustomTable
    },
    data() {
        return {
            fields: [
                {
                    name: this.$t("common.id"),
                    key: "id",
                    class: ""
                },
                {
                    name: this.$t("pages.verificationRequest.cols.messageCount"),
                    key: "messages_count"
                },
                {
                    name: this.$t("common.status"),
                    scopedSlots: {customRender: "status"}
                },
                {
                    name: this.$t("common.createdAt"),
                    scopedSlots: {customRender: "createdAt"}
                },
                {
                    name: this.$t("common.action"),
                    key: "action",
                    class: "",
                    scopedSlots: {customRender: "actions"},
                }
            ],
            actions: [
                {
                    name: "refresh",
                    icon: "bi-arrow-repeat",
                    label: "btn.refresh"
                }
            ],
            status: {
                1: {
                    code: 'pending',
                    badge: 'badge-light-warning'
                },
                2: {
                    code: 'approved',
                    badge: 'badge-light-success'
                },
                3: {
                    code: 'denied',
                    badge: 'badge-light-danger'
                }
            },
            form: {
                title: '',
                loading: false,
                fileList: [],
                uploadList: [],
                identity: {
                    fileList: [],
                    uploadList: [],
                },
                certificate: {
                    fileList: [],
                    uploadList: [],
                },
                data: {}
            }
        }
    },
    computed: {
        table() {
            return this.$store.state.verificationRequest.table;
        },
        verifyRequestAcceptFiles() {
            let accepts = [];

            ['image', 'document', 'compressed'].forEach((group) => {
                let prefix = ((group === 'image') ? 'image/' : '.');

                accepts.push(this.$root.acceptFileSupported(group, prefix));
            });

            return accepts.join(', ');
        },
        showTable() {
            let status = true;

            if (!this.table.data.length || this.table.data[0].status_id == 3) {
                status = false;
            }

            return status;
        }
    },
    mounted() {
        this.setCurrentPageBreadcrumbs(this.$t("pages.verificationRequest.title"));
        this.$store.dispatch('verificationRequest/get', {
            page: {},
            filterData: Object.assign({
                sort: 'id:desc',
            }, this.$root.getFilterWithUrl({}))
        });
    },
    methods: {
        handleClickAction(name) {
            switch (name) {
                case "refresh":
                    this.refreshTable();
                    break;

                default:
                    break;
            }
        },
        refreshTable() {
            this.$store.dispatch("verificationRequest/refresh");
        },
        handleTableChange(pagination, filterData) {
            this.$store.dispatch("verificationRequest/get", {
                page: pagination,
                filterData: Object.assign({
                    sort: 'id:desc'
                }, filterData)
            });
        },
        handleChangeFile(scope, file, fileList) {
            let variable = scope !== 'general' ? this.form[scope] : this.form;

            variable['fileList'] = fileList;
            variable['uploadList'] = fileList;
        },
        newVerifyRequest(){
            this.form.data = {};
            this.form.fileList = [];
            this.form.uploadList = [];
            this.form.identity = {
                fileList: [],
                uploadList: [],
            };
            this.form.identity = {
                fileList: [],
                uploadList: [],
            };

            this.form.title = this.$t('pages.verificationRequest.create.modalTitle');
            this.showModal(this.$refs.verifyRequestModal);
        },
        onSubmit(){
            this.$refs.verifyRequestForm.validate((valid) => {
                if (valid) {
                    if (!(this.form.identity.uploadList.length && this.form.certificate.uploadList.length)) {
                        this.$notify({
                            type: 'warning',
                            title: this.$t("messages.warning"),
                            message: this.$t("pages.verificationRequest.create.warning.firstMessage"),
                        })
                        return false;
                    }

                    this.form.uploadList = [...this.form.identity.uploadList, ...this.form.certificate.uploadList];

                    this.verifyRequest();
                } else {
                    return false;
                }
            });
        },
        async verifyRequest() {
            this.form.loading = true;

            try {
                let createResult = await this.createVerifyRequest();
                if (!createResult.status) {
                    throw createResult.message;
                }

                this.form.data.request_id = createResult.data.id;

                let uploadResult = await this.uploadVerifyAttachment();
                if (!uploadResult.status) {
                    throw uploadResult.message;
                }

                let addMessageResult = await this.addVerifyRequestMessageWithDelay(2000);
                if (!addMessageResult.status) {
                    throw addMessageResult.message;
                }

                this.refreshTable();
                this.$notify({type: 'success', title: this.$t("messages.success"), message: this.$t("messages.actionOk")});
            } catch (error) {
                this.deleteVerifyRequest();
                this.$notify({type: 'error', title: this.$t("messages.error"), message: this.$t('pages.verificationRequest.create.responseMessage.createRequest')});
            }

            this.hideModal(this.$refs.verifyRequestModal);
            this.form.loading = true;
        },
        async createVerifyRequest() {
            try {
                let data = {};

                await this.axios.post(this.endpoint.get('verification_request')).then(response => {
                    if (!response.data.status) {
                        throw "error_create_verify_request"
                    }

                    data = response.data.data;
                }).catch((error) => {
                    throw error.response
                });

                return {status: true, message: "success_create_verify_request", data: data};
            } catch (error) {
                return {status: false, error: error};
            }
        },
        async uploadVerifyAttachment() {
            try {
                const formData = new FormData();

                this.form.uploadList.forEach(file => {
                    formData.append("file[]", file.raw);
                });

                await this.axios.post(this.endpoint.get('upload'), formData).then(response => {
                    if (!response.data.status) {
                        throw "error_upload_verify_attachment"
                    }
                    let data = response.data.data;
                    this.form.data.attachments = data.map(file => file.id);
                }).catch((error) => {
                    throw error.response
                });

                return {status: true, message: "success_submit_verify_request"};
            } catch (error) {
                return {status: false, error: error};
            }
        },
        async addVerifyRequestMessageWithDelay(delay){
            return new Promise((resolve) => {
                setTimeout(async () => {
                    let result = await this.addVerifyRequestMessage();
                    resolve(result);
                }, delay);
            });
        },
        async addVerifyRequestMessage(){
            try {
                await this.axios.post(this.endpoint.get('verification_request_message'), this.form.data).then(response => {
                    if (!response.data.status) {
                        throw "error_add_verify_message"
                    }
                }).catch((error) => {
                    throw error.response
                });

                return {status: true, message: "success_submit_verify_request"};
            } catch (error) {
                return {status: false, error: error};
            }
        },
        deleteVerifyRequest(){
            if(this.form.data.request_id) {
                this.axios.delete(this.endpoint.get('verification_request') + '/' + this.form.data.request_id);
            }
        }
    }
}
</script>

<style>
.upload-file .el-upload {
    width: 100%;
}

.upload-file .el-upload .el-upload-dragger {
    width: 100%;
}

.upload-file .svg-icon svg {
    height: 1em;
    width: 1em;
}
</style>